
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators, IValidatingObject } from './../../../scripts/formcontrols'
import { DrugDto } from "./../../../dto/DrugDto"
import { PatientOrderItemDto } from "./../../../dto/Dtos"
import { OrderStatus } from "./../../../dto/OrderStatusEnum"

import Dal from './../../../scripts/dataaccess';

export class OrderItemController extends FormPageValidator {
    index: number;
    drug: FormElementController<DrugDto>;
    quantity: FormElementController<number>;
    instruction: FormElementController<string>;
    notes: FormElementController<string>;
    drugStatus: FormElementController<string>;
    startDate: FormElementController<Date>;
    endDate: FormElementController<Date>;
    orderStatus: FormElementController<OrderStatus>;
    dispensationItemId: string;
    IsNew: boolean;
    isEditing: boolean;
    carehomePatientOrderItemStatus: number;

    original: PatientOrderItemDto;

    constructor(item: PatientOrderItemDto, isNew: boolean, index: number) {
        super();
        //console.log(item);
        this.original = Object.assign({}, item) as PatientOrderItemDto;

        this.isEditing = false;
        this.IsNew = isNew;
        this.index = index;

        var drugValidator = new FormElementValidator(true);
        var quantityValidator = new FormElementValidator(true);
        var statusValidator = new FormElementValidator(true);

        var drug = new DrugDto();
        drug.apid = item.apid;
        drug.vpid = item.vpid;
        drug.searchText = item.drugName;

        this.carehomePatientOrderItemStatus = item.carehomePatientOrderItemStatus;
        this.drug = new FormElementController<DrugDto>("Drug", drug, drugValidator);
        this.quantity = new FormElementController<number>("Quantity", item.quantity, quantityValidator);
        this.instruction = new FormElementController<string>("Instruction", item.dosageInstruction);
        this.notes = new FormElementController<string>("Notes", item.notes);
        this.startDate = new FormElementController<Date>("StartDate", item.startDate);
        this.endDate = new FormElementController<Date>("EndDate", item.endDate);
        this.orderStatus = new FormElementController<OrderStatus>("OrderStatus", OrderStatus.Get(item.patientOrderItemContinuityStatus));
        this.dispensationItemId = item.dispensationItemId;
        //this.drugStatus = new FormElementController<string>("Status", item.status, statusValidator);

        this.addValidators(drugValidator, quantityValidator, statusValidator);
    }

    public GetDto(): PatientOrderItemDto {
        var dto = new PatientOrderItemDto();

        dto.apid = this.drug.value.apid;
        dto.vpid = this.drug.value.vpid;
        dto.drugName = this.drug.value.searchText;
        
        dto.carehomePatientOrderItemStatus = this.carehomePatientOrderItemStatus;
        dto.quantity = this.quantity.value;
        dto.dosageInstruction = this.instruction.value;
        dto.notes           = this.notes.value;
        dto.startDate       = this.startDate.value;
        dto.endDate = this.endDate.value;
        dto.patientOrderItemContinuityStatus = this.orderStatus.value.id;
        dto.dispensationItemId = this.dispensationItemId;
        dto.id = this.original.id;
        dto.patientId = this.original.patientId;
        dto.pharamcyPatientId = this.original.pharamcyPatientId;

        return dto;
    }
}

export class OrderGroupController extends FormPageValidator {

    public OrderItems: Array<OrderItemController>
    private patientId: string;
    private startDate: Date;
    private endDate: Date;

    constructor() {
        super();
        this.OrderItems = new Array<OrderItemController>();
    }

    public Load(patientId: string, startDate: Date, endDate: Date) {

        this.patientId = patientId;
        this.startDate = startDate;
        this.endDate = endDate;

        var dal = new Dal();
        var result = new Array<OrderItemController>();
        dal.GetPatientOrders(patientId, startDate, endDate).then(data => {

            var index = 0;
            for (var item of data) {
                result.push(new OrderItemController(item, false, index++));
            }
            this.addValidatorsArray(result as IValidatingObject[]);
            this.OrderItems = result;
        });
    }

    public async Submit(): Promise<boolean> {
        var postData = new Array<PatientOrderItemDto>();
        for (var item of this.OrderItems) {
            postData.push(item.GetDto());
        }

        var dal = new Dal();
        return await dal.SavePatientOrders(this.patientId, this.startDate, this.endDate, postData);
    }

    public AddNew() {
        
        var index = 0;
        for (var item of this.OrderItems) {
            if (item.index > index)
                index = item.index;
        }
        var orderItem = new PatientOrderItemDto();
        orderItem.startDate = this.startDate;
        orderItem.endDate = this.endDate;
        orderItem.patientOrderItemContinuityStatus = 100;
        var itemController = new OrderItemController(orderItem, true, ++index);
        this.addValidator(itemController);
        return itemController;
        //this.OrderItems.push(itemController);
    }

    public Remove(key: number) {
        //console.log("Element removed", key)
        for (var i = 0; i < this.OrderItems.length; i++) {
            if (this.OrderItems[i].index == key) {
                this.removeValidator(this.OrderItems[i]);
                this.OrderItems.splice(i, 1);
                return;
            }
        }
    }
}


export class OrderItemControllerHelper {
    constructor() { }

    public GetControllers(patientId: string, startDate: Date, endDate: Date): Array<OrderItemController> {

        var dal = new Dal();
        var result = new Array<OrderItemController>();
        dal.GetPatientOrders(patientId, startDate, endDate).then(data => {
            //console.log("Patient Orders");
            //console.log(data);
            var index = 0;
            for (var item of data) {
                result.push(new OrderItemController(item, false, index++));
            }
        });
        return result;
    }

    public AddNew(items: Array<OrderItemController>, order: PatientOrderItemDto) {
        var index = 0;
        for (var item of items) {
            if (item.index > index)
                index = item.index;
        }

        items.push(new OrderItemController(order, true, ++index));
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/PatientOrderItems/OrderItemController.ts